import { hasOwnProperty } from "../../../infra3d";
import { USERINPUTTYPE } from "../../userinput/internal";
import { Obj } from "../../internal";
export var STRATEGYINITSTATE;
(function (STRATEGYINITSTATE) {
    STRATEGYINITSTATE[STRATEGYINITSTATE["OFF"] = 0] = "OFF";
    STRATEGYINITSTATE[STRATEGYINITSTATE["PENDING"] = 1] = "PENDING";
    STRATEGYINITSTATE[STRATEGYINITSTATE["DONE"] = 2] = "DONE";
})(STRATEGYINITSTATE || (STRATEGYINITSTATE = {}));
/**
 * Base-class for strategies to reload Feature-Layers.
 * @class Strategy
 * @extends Obj
 */
export class Strategy extends Obj {
    constructor(scene) {
        super();
        /**
         * list of layers managed by the strategy.
         * @type {Array}
         */
        this.layers = [];
        /**
         * Information retrieved by the strategy to pass over to the load function of the layer
         * @type {any}
         */
        this._loadinfo = { bbox: null, srid: -1 };
        /**
         * Indicator of the current state of the strategy.
         * This is used because layers can be added before or while _loadinfo is loaded.
         * @type {STRATEGYINITSTATE}
         */
        this._state = STRATEGYINITSTATE.OFF;
        /**
         * event-id for unsubscribing on destroy.
         * @type {any}
         * @private
         */
        this._layerupdatedevt = null;
        this.scene = scene;
    }
    /**
     * initializes the strategy once a layer has been added and the strategy is not yet initialized.
     * @protected
     */
    _init() {
        this._state = STRATEGYINITSTATE.PENDING;
        //register layerupdated
        /**
         * generally layers can be reloaded manually using its reload function. eg. mylayer.reload().
         * The reload function of the layer does not call the loadFeatures-Functions of the layer itself,
         * because he doesn't know the current loadinfo (extent, srid,etc.). Therefore the reload-function of
         * the layer sets the option needsReload to true and dispatches the layerupdated-event. The strategy
         * then must listen to the layerupdated-event to reload the layer.
         */
        this._layerupdatedevt = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE["LAYERUPDATED"], (layer) => {
            if (layer.needsReload)
                this._update();
        }, this);
    }
    /**
     * adds or registers a layer for the strategy. By the time of registring the 'needsReload'-indicator of
     * all layers is set to true.
     * @param layer
     * @param loadfunction? function that should be called on the layer by the strategy. default = "loadFeatures"
     * @param args? Arguments that should be passed to the load-function (default = ["bbox", "srid"])
     */
    register(layer, loadfunction, args) {
        this.layers.push({
            layer: layer,
            loadfunction: loadfunction || layer.loadFeatures,
            args: args || ["bbox", "srid"],
        });
        if (this._state == STRATEGYINITSTATE.OFF)
            this._init();
        this._update();
    }
    /**
     * removes a layer from the strategy
     * @param layer
     */
    remove(layer) {
        for (let i = 0; i < this.layers.length; i++) {
            if (this.layers[i].layer === layer)
                this.layers.splice(i, 1);
        }
        if (this.layers.length == 0)
            this._destroy();
    }
    /**
     * calls the load-function of the layer.
     * @protected
     */
    _update() {
        if (this._state == STRATEGYINITSTATE.DONE) {
            for (let i = 0; i < this.layers.length; i++) {
                const layer_info = this.layers[i];
                if (layer_info.layer.needsReload) {
                    layer_info.layer.needsReload = false;
                    const args = [];
                    for (const arg in layer_info.args) {
                        if (hasOwnProperty(this._loadinfo, layer_info.args[arg])) {
                            args.push(this._loadinfo[layer_info.args[arg]]);
                        }
                    }
                    layer_info.loadfunction.apply(layer_info.layer, args);
                }
            }
        }
    }
    /**
     * destroys the strategy and unsubsribes registered events.
     * @protected
     */
    _destroy() {
        this._loadinfo = { bbox: null, srid: -1 };
        this._state = STRATEGYINITSTATE.OFF;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.LAYERUPDATED, this._layerupdatedevt);
        this._layerupdatedevt = null;
    }
}
//# sourceMappingURL=strategy.js.map